const companyDepts = {
  '上海绿谷别墅管理有限公司': ['销售服务部', '物业部', '综合管理部', '保安部', '管家部', '工程部'],
  '上海新泾房地产开发有限公司': ['工程部', '配套部', '凌鸿公司', '动迁公司'],
  '上海鑫光企业发展有限公司': ['物业部'],
  '上海荣茂工贸有限公司': ['市驾校', '荣茂汽服', '锦茂日产']
}
export default companyDepts
// , '绿谷会', '采购部',